import { render, staticRenderFns } from "./ImportExportCustomers.vue?vue&type=template&id=5edb3ba6"
import script from "./ImportExportCustomers.vue?vue&type=script&lang=js"
export * from "./ImportExportCustomers.vue?vue&type=script&lang=js"
import style0 from "./ImportExportCustomers.vue?vue&type=style&index=0&id=5edb3ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports